export default __webpack_public_path__ + "bankDash.678f86b75ab6e81dd0c7.svg";